/* eslint-disable import/prefer-default-export */
/* eslint-disable no-unused-vars */
import { API_DOMAIN, API_DOMAIN_LOCAL, API_ENDPOINT_BASE_DOKAN } from '../ApiEnv';

// vendor preferences Api
export const preferencesAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/vendor-dashboard/preferences`;
export const vendorDashBoardAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/vendor-dashboard`;
export const settingsAPI = `${API_DOMAIN_LOCAL}${API_ENDPOINT_BASE_DOKAN}/settings`;
